module.exports = __webpack_public_path__ + "static/media/1.904bcc27.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/pioricost-fruit/certificaciones/1.jpg
// module id = 50
// module chunks = 0